import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios"
import Vueaxios from "vue-axios"
import {Loading ,MessageBox ,Message} from 'element-ui';
import { Dialog } from 'vant';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Vueaxios , axios )
import vueEsign from 'vue-esign'
Vue.use(vueEsign)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false

let loadingInstance='';
function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}
if (isMobile()) { //手机
    axios.interceptors.request.use(function (config) {
        if (config.url != '/api/Pay/GetOrderStatus' && config.url != '/api/MemberPay/GetOrderStatus' && config.url != '/api/User/Sign') {
            loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)',spinner:'el-icon-loading'});
        }
        
        return config;
        }, function (err) {
        return Promise.reject(err);
      });
      axios.interceptors.response.use(function (response) {
        if (loadingInstance) {
            loadingInstance.close()
        }
        if (response.config.url !== '/api/User/Login') {
            if(response.data.code === 501){
                // Message.error({
                //     message: response.data.msg,
                // });
                Dialog.alert({
                    message: response.data.msg,
                    theme: "round-button",
                })
            }else if (response.data.code === 500) {
                Dialog.alert({
                    message: response.data.msg,
                    theme: "round-button",
                }).then(() => {
    
                });
            }else if (response.data.code === 502) {
                Dialog.alert({
                    message: response.data.msg,
                    theme: "round-button",
                }).then(() => {
    
                });
            
            } else if (response.data.code === 401) {
              
                var urlRouter = response.request.responseURL.split('/api/')[1]
                if (urlRouter !== 'SignUp/GetCardID'){
                    Dialog.alert({
                        message: response.data.msg,
                        theme: "round-button",
                    }).then(() => {
                        window.localStorage.clear();
                        router.push({ name: 'home' })
                    });
                }
            } else if (response.data.code === 400) {
                Dialog.alert({
                    message: response.data.msg,
                    theme: "round-button",
                }).then(() => {
                   
                });
            }
        }
      return response;
      }, function (error) {
        if (loadingInstance) {
            loadingInstance.close()
        }
        if (error.config ) {
            if (error.config.url !== '/api/SignUp/OrderQuery') {
                if (error.response.status) {
                    let statusC =  error.response.status
                    if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503  || statusC == 504 || statusC == 401) {
                        // Message.error({
                        //     message:'错误提示'+statusC,
                        // });
                        Dialog.alert({
                            message: '网络异常',
                            theme: "round-button",
                        }).then(() => {
                            
                        });
                    } 
                }
            }
           
        }
        return Promise.reject(error.config);
       
      });
}else {
    axios.interceptors.request.use(function (config) {
        if (config.url != '/api/Pay/GetOrderStatus' && config.url != '/api/MemberPay/GetOrderStatus' && config.url != '/api/User/Sign') {
            loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)'});
        }
        
        return config;
        }, function (err) {
        return Promise.reject(err);
      });
      axios.interceptors.response.use(function (response) {
        if (loadingInstance) {
            loadingInstance.close()
        }
        if (response.config.url !== '/api/User/Login') {
            if(response.data.code === 501){
                Message.error({
                    message: response.data.msg,
                });
            
            }else if (response.data.code === 500) {
                Message.error({
                message: response.data.msg,
                });
            }else if (response.data.code === 502) {
                Message.error({
                    message: response.data.msg,
                });
                router.push({name: 'index'})
            
            } else if (response.data.code === 401) {
              
                var urlRouter = response.request.responseURL.split('/api/')[1]
                if (urlRouter !== 'SignUp/GetCardID'){
                    Message.error({
                        message: response.data.msg,
                    });
                }
                // router.push({name: 'login'})
                const cardId = window.localStorage.getItem('cardid');
        
                // 判断如果cardid等于admin，则跳转到manage页面
                if (cardId === 'admin') {
                    router.push({name: 'manage'});
                } else {
                    router.push({name: 'login'});
                }
            } else if (response.data.code === 400) {
                Message.error({
                    message: response.data.msg,
                });
            }
        }
      return response;
      }, function (error) {
        if (loadingInstance) {
            loadingInstance.close()
        }
        if (error.config ) {
            if (error.config.url !== '/api/SignUp/OrderQuery') {
                if (error.response.status) {
                    let statusC =  error.response.status
                    if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503  || statusC == 504 || statusC == 401) {
                        Message.error({
                            message:'错误提示'+statusC,
                        });
                    } 
                }
            }
           
        }
        return Promise.reject(error.config);
       
      });
}


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js